<template>
	<div>
    <!-- <div id="main" :style="{ 'width': parseInt(style.width) + 'px', 'height': parseInt(style.height) + 'px' }"></div> -->
    <div id="main" style="width: 1200px; height: 300px"></div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default() {
        return {}
      }
    },
    style: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      // chartOption: {
      //   title: { text: '图表' },
      //   tooltip: {
      //     trigger: 'item',
      //     axisPointer: {            // 坐标轴指示器，坐标轴触发有效
      //       type: 'shadow'          // 默认为直线，可选为：'line' | 'shadow'
      //     }
      //   },
      //   legend: {
      //     data: ['A项目','B项目']
      //   },
      //   xAxis: [
      //     {
      //       type: 'category',
      //       data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      //     }
      //   ],
      //   yAxis: [
      //     {
      //       type: 'value'
      //     }
      //   ],
      //   series: [
      //     {
      //       name: 'A项目',
      //       type: 'bar',
      //       barWidth: '20%',
      //       data: [10, 52, 200, 334, 390, 330, 220]
      //     },
      //     {
      //       name: 'B项目',
      //       type: 'bar',
      //       barWidth: '20%',
      //       data: [10, 52, 200, 334, 390, 330, 220]
      //     }
      //   ]
      // }
    }
  },
  created() {
    setTimeout(() => {
      const myChart = _chart.init('main')
      myChart.setOption(this.option)
    }, 0)
  }
}
</script>


// WEBPACK FOOTER //
// barChart.vue?631419da